import {
  Grid,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
} from '@mui/material';
import React from 'react';

import CheckedRadioIcon from '../../../../packages/common/shared-ui/src/icons/CheckedRadioIcon';
import UncheckedRadioIcon from '../../../../packages/common/shared-ui/src/icons/UncheckedRadioIcon';
import { useTranslation } from '../../../../packages/common/utils/getLocalString';

const ResourcePlanSaveOptions = ({
  errorData,
  saveOption,
  setSaveOption,
  handleButtonClick,
}) => {
  const getLocalString = useTranslation();

  return (
    <Grid
      container
      direction='column'
      sx={{
        marginBottom: 2,
      }}
    >
      <Typography
        variant='h3'
        sx={{
          fontWeight: 600,
          color: '#E03737',
        }}
      >
        {getLocalString('errors', 'issueUpdated')}
      </Typography>
      <Grid
        container
        direction='column'
        sx={{
          marginLeft: 2,
        }}
      >
        {errorData &&
          errorData?.map((item, index) => {
            const formattedText = [];

            if (
              item.updatedValues.assignedUser &&
              ('new' in item.updatedValues.assignedUser ||
                'old' in item.updatedValues.assignedUser)
            ) {
              const oldValue =
                item.updatedValues.assignedUser.old !== null
                  ? item.updatedValues.assignedUser.old
                  : getLocalString('labels', 'null');
              const newValue =
                item.updatedValues.assignedUser.new !== null
                  ? item.updatedValues.assignedUser.new
                  : getLocalString('labels', 'null');

              formattedText.push(
                `Назначено изменилось с ${oldValue} на ${newValue}`,
              );
            }

            if (
              item.updatedValues.estimatedHours &&
              ('new' in item.updatedValues.estimatedHours ||
                'old' in item.updatedValues.estimatedHours)
            ) {
              const oldValue =
                item.updatedValues.estimatedHours.old !== null
                  ? item.updatedValues.estimatedHours.old
                  : getLocalString('labels', 'null');
              const newValue =
                item.updatedValues.estimatedHours.new !== null
                  ? item.updatedValues.estimatedHours.new
                  : getLocalString('labels', 'null');

              formattedText.push(
                `Оценка временных затрат изменилась с ${oldValue} ч на ${newValue} ч`,
              );
            }

            if (
              item.updatedValues.startDate &&
              ('new' in item.updatedValues.startDate ||
                'old' in item.updatedValues.startDate)
            ) {
              const oldDateValue = item.updatedValues.startDate.old
                ? new Date(
                    item.updatedValues.startDate.old,
                  ).toLocaleDateString()
                : getLocalString('labels', 'null');
              const newDateValue = item.updatedValues.startDate.new
                ? new Date(
                    item.updatedValues.startDate.new,
                  ).toLocaleDateString()
                : getLocalString('labels', 'null');

              formattedText.push(
                `Дата начала изменилась с ${oldDateValue} на ${newDateValue}`,
              );
            }

            if (
              item.updatedValues.endDate &&
              ('new' in item.updatedValues.endDate ||
                'old' in item.updatedValues.endDate)
            ) {
              const oldEndDateValue = item.updatedValues.endDate.old
                ? new Date(item.updatedValues.endDate.old).toLocaleDateString()
                : getLocalString('labels', 'null');
              const newEndDateValue = item.updatedValues.endDate.new
                ? new Date(item.updatedValues.endDate.new).toLocaleDateString()
                : getLocalString('labels', 'null');

              formattedText.push(
                `Дата завершения изменилась с ${oldEndDateValue} на ${newEndDateValue}`,
              );
            }

            return (
              <Typography
                key={index}
                variant='h4'
                sx={{
                  fontWeight: 600,
                }}
              >
                {`${getLocalString('labels', 'forTheTask')} ${item?.issueName}: ${formattedText.join(', ')}`}
              </Typography>
            );
          })}
      </Grid>
      <Grid
        container
        wrap='nowrap'
        direction='column'
        spacing={0}
        sx={{
          marginLeft: 4,
        }}
      >
        <RadioGroup
          value={saveOption}
          onChange={e => setSaveOption(e.target.value)}
          defaultValue={0}
        >
          <FormControlLabel
            value='save_all'
            control={
              <Radio
                disableRipple
                icon={
                  <UncheckedRadioIcon
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                  />
                }
                checkedIcon={
                  <CheckedRadioIcon
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                  />
                }
              />
            }
            label={getLocalString('messages', 'applyChanges')}
          />
          <FormControlLabel
            value='save_all_expect_changes'
            control={
              <Radio
                disableRipple
                icon={
                  <UncheckedRadioIcon
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                  />
                }
                checkedIcon={
                  <CheckedRadioIcon
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                  />
                }
              />
            }
            label={getLocalString('messages', 'applyMyChanges')}
          />
          <FormControlLabel
            value='cancel_changes'
            control={
              <Radio
                disableRipple
                icon={
                  <UncheckedRadioIcon
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                  />
                }
                checkedIcon={
                  <CheckedRadioIcon
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                  />
                }
              />
            }
            label={getLocalString('errors', 'clearingChanges')}
          />
        </RadioGroup>
        <Grid>
          <Button
            variant='defaultBluePrimary'
            disableRipple
            onClick={handleButtonClick}
          >
            <Typography
              variant='h4'
              sx={{
                fontWeight: 600,
              }}
            >
              {getLocalString('labels', 'accept')}
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ResourcePlanSaveOptions;
